var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", [_vm._v("Thank You")]),
      _vm._v(" "),
      _c("p", [_vm._v("Your finance application was submitted successfully.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }